// ----------------------------------------------------------------------
export const mockImgBatch = (index) => `/static/batchImages/img_${index}.png`;
export const mockImgIdo = (index) => `/static/idoImages/img_${index}.png`;
